import {
    ADD_SUGGESTED_DAMAGE,
    DELETE_SUGGESTED_DAMAGE,
    DELETE_SUGGESTED_DAMAGE_IMAGE,
    UPDATE_SUGGESTED_DAMAGE_IMAGE,
    LOAD_WORK_ORDER_SUCCESS,
    MANUALLY_ADD_SUGGESTED_DAMAGE,
    UNLOAD_WORK_ORDER
} from "../actions/dispatchTypes";
import update from "immutability-helper";
import {calculateDamageKey} from "./conditionReducer";
import {ADDED, DELETED, EDITED, MANUAL, UPDATED} from "../utils/constants";

export default function suggestedDamageReducer(state = null, action) {
    switch (action.type) {
        case LOAD_WORK_ORDER_SUCCESS:
            return initialSuggestedDamages(action.payload) || state;
        case ADD_SUGGESTED_DAMAGE:
            return addDamage(state, action.payload)
        case DELETE_SUGGESTED_DAMAGE:
            return deleteDamage(state, action.payload)
        case DELETE_SUGGESTED_DAMAGE_IMAGE:
            return deleteSuggestedDamageImage(state, action.payload.damageId)
        case UPDATE_SUGGESTED_DAMAGE_IMAGE:
            return updateSuggestedDamageImage(state, action.payload.damageId, action.payload.path)
        case MANUALLY_ADD_SUGGESTED_DAMAGE:
            return manuallyAddDamage(state, action.payload)
        case UNLOAD_WORK_ORDER:
            return null;
        default:
            return state;
    }
}


function initialSuggestedDamages(payload) {
    let suggestedDamages = payload.suggestedDamages;
    if (suggestedDamages?.damages?.length) {
        suggestedDamages.damages.map(damage => {
            damage.artCodes.damageKey = calculateDamageKey(damage.artCodes);
            return damage;
        });
    }
    return suggestedDamages;
}

function getAssignedDamage(damage, addedDamage) {
    return Object.assign(damage, {
        action: addedDamage.isEdited ? EDITED : ADDED,
        topnIndex: addedDamage.topnIndex
    });
}

function addDamage(state, addedDamage) {
    const damages = state.damages.map(damage => damage.artCodes.damageKey === addedDamage.artCodes.damageKey ? getAssignedDamage(damage, addedDamage) : damage);
    console.log("mapped suggested damage", damages);
    return update(state, {
        $merge: {
            damages: damages
        }
    })
}

function deleteDamage(state, deletedDamage) {
    const damages = state.damages.map(damage => damage.artCodes.damageKey === deletedDamage.artCodes.damageKey ? Object.assign(damage, {action: DELETED}) : damage);
    return update(state, {
        $merge: {
            damages: damages
        }
    })
}

function deleteSuggestedDamageImage(state, damageId) {
    const damages = state.damages.map(damage => 
        damage.artCodes.damageId === damageId 
            ? Object.assign({}, damage, { 
                path: null,
                imageAction: DELETED 
              })
            : damage
    );
    return update(state, {
        $merge: {
            damages: damages
        }
    })
}

function updateSuggestedDamageImage(state, damageId, path) {
    const damages = state.damages.map(damage => 
        damage.artCodes.damageId === damageId 
            ? Object.assign({}, damage, { 
                path: path,
                imageAction: UPDATED 
              })
            : damage
    );
    return update(state, {
        $merge: {
            damages: damages
        }
    })
}

function manuallyAddDamage(state, manuallyAddedDamage) {
    const damages = state.damages.map(damage => damage.artCodes.damageKey === manuallyAddedDamage ? Object.assign(damage, {action: MANUAL}) : damage);
    return update(state, {
        $merge: {
            damages: damages
        }
    })
}